export enum UserRole {
    SUPER_ADMIN = "superadmin",
    PROVIDER = "provider",
    BILLER = "biller",
    CODER = "coder",
    AUDITOR = "auditor",
    BILLER_ADMIN = "billeradmin",
    CLIENT_SUPPORT = "clientsupport",
    CLIENT = "client",
    USER_SUPPORT = "usersupport",
    SUPPORT_GENERAL = "supportgeneral",
    SUPPORT_ADMIN = "supportadmin",
    AUDITOR_ADMIN = "auditoradmin",
}

export enum UserPermisions {
    CLIENT_NOTES_ALL_READ = "client_notes_all_read",
    CLIENT_INFO_NOTES_READ = "clientinfo_notes_read",
    CLIENT_INFO_NOTES_WRITE = "clientinfo_notes_write",
    CLIENT_INFO_NOTES_CHANGE_REQUEST_WRITE = "clientinfo_notes_changerequest_write",
    CLIENT_INFO_NOTES_AI_REVIEW = "clientinfo_notes_ai_review",
    CLIENT_INFO_NOTES_APPROVAL = "clientinfo_notes_approval",
    CLIENT_INFO_NOTES_FLAG_FOR_AUDIT_WRITE = "clientinfo_flag_for_audit_write",

    CLIENT_INFO_ALL_ADMIN = "clientinfo_all_admin",

    CLIENT_INFO_DOCUMENT_READ = "client_info_document_read",
    CLIENT_INFO_DOCUMENT_WRITE = "client_info_document_write",

    CLIENT_INFO_MEMO_READ = "client_info_memo_read",
    CLIENT_INFO_MEMO_WRITE = "client_info_memo_write",

    CLIENT_INFO_COLLECTIONS_NOTES_READ = "client_info_collections_notes_read",
    CLIENT_INFO_COLLECTIONS_NOTES_WRITE = "client_info_collections_notes_write",

    CLIENT_INFO_TAGS_READ = "client_info_tags_read",
    CLIENT_INFO_TAGS_WRITE = "client_info_tags_write",

    CLIENT_INFO_PAYMENTS_READ = "client_info_payments_read",
    CLIENT_INFO_PAYMENTS_WRITE = "client_info_payments_write",

    CLIENT_INFO_FEES_READ = "client_info_fees_read",
    CLIENT_INFO_FEES_WRITE = "client_info_fees_write",

    CLIENT_INFO_INSURANCE_READ = "client_info_insurance_read",
    CLIENT_INFO_INSURANCE_WRITE = "client_info_insurance_write",

    CLIENT_INFO_PERSONAL_READ = "client_info_personal_read",
    CLIENT_INFO_PERSONAL_WRITE = "client_info_personal_write",

    CLIENT_INFO_PROVIDER_READ = "client_info_provider_read",
    CLIENT_INFO_PROVIDER_WRITE = "client_info_provider_write",

    CLIENT_INFO_SESSION_READ = "client_info_session_read",
    CLIENT_INFO_SESSION_WRITE = "client_info_session_write",

    CLIENT_INFO_ALL_READ = "client_info_all_read",
    CLIENT_INFO_ALL_WRITE = "client_info_all_write",

    CLIENT_INFO_INVOICE_READ = "client_info_invoice_read",
    CLIENT_INFO_INVOICE_WRITE = "client_info_invoice_write",

    CLIENT_INFO_COMMUNICATIONS_READ = "client_info_communications_read",
    CLIENT_INFO_COMMUNICATIONS_WRITE = "client_info_communications_write",

    USER_INFO_ALL_ADMIN = "user_info_all_admin",
    USER_INFO_ALL_READ = "user_info_all_read",
    USER_INFO_ALL_WRITE = "user_info_all_write",

    PROVIDER_REPORTS_READ = "provider_reports_read",
    BILLING_REPORTS_READ = "billing_reports_read",
    PROVIDER_INFO_UPDATE = "provider_info_update",
    PROVIDER_SUPERVISOR_OVERRIDE_UPDATE = "provider_supervisor_override_update",

    PROVIDER_INFO_READ = "provider_info_read",

    AUDIT_DASHBOARD_READ = "audit_dashboard_read",

    BILLING_DASHBOARD_READ = "billing_dashboard_read",

    TODO_ALL_READ = "todo_all_read",
    TODO_ALL_DELETE = "todo_all_delete",
    NOTE_MESSAGING = "note_messaging",
    PRACTICE_SETTING_READ = "practice_setting_read",
    PRACTICE_SETTING_WRITE = "practice_setting_write",
    PRACTICE_SETTING_ADMIN = "practice_setting_admin",
    PROVIDER_STATUS_RULE_READ = "provider_status_rule_read",
    PROVIDER_STATUS_RULE_WRITE = "provider_status_rule_write",
    NOTE_RULE_BYPASS_READ = "note_rule_bypass_read",
    NOTE_RULE_BYPASS_WRITE = "note_rule_bypass_write",
    PROVIDER_ACCOMMODATION_READ = "provider_accommodation_read",
    PROVIDER_ACCOMMODATION_WRITE = "provider_accommodation_write",
    NOTE_SUPERVISOR_REVIEW_SKIP = "note_supervisor_review_skip",
    SUPPORT_PAYMENT_CORRECTION_WRITE = "support_payment_correction_write",
    SUPPORT_PAYMENT_ADMIN_WRITE = "support_payment_admin_write",
    SUPPORT_CLAIM_REMITTANCE_WRITE = "support_claim_remittance_write",
    SUPPORT_CLAIM_REMITTANCE_ADMIN_WRITE = "support_claim_remittance_admin_write",
    SUPPORT_NOTE_CORRECTION_WRITE = "support_note_correction_write",
    SUPPORT_SESSION_DELETE = "support_session_delete",
    SUPPORT_USER_MANAGEMENT = "support_user_management",
    SUPPORT_MFA_RESET = "support_mfa_reset",
    SUPPORT_INSURANCE_PROVIDER_WRITE = "support_insurance_provider_write",
}
export enum InternalUsersStatus {
    ACTIVE = "active",
    DEACTIVATED = "deactivated",
}

export enum UserRoleDescription {
    provider = "Provide essential medical care to clients",
    superadmin = "Has access to all pages and functions",
    supervisor = "Provider who is also in charge of supervising others",
    biller = "Preparing and submitting billing data and medical claims to insurance companies",
    coder = "Responsible for translating physicians’ reports into useful uniform medical codes",
    auditor = "Audits specified number of records per coder as defined in the system coding audit plan",
    billeradmin = "Has the rights to manage subscription and payment methods, and download receipts",
    client = "Practice client seeing one or more clinicians",
    clientsupport = "Point of contact for clients",
    supportgeneral = "Provides routine product support",
    supportadmin = "Provides elevated product and account support",
}

export interface IUser {
    user_id: string;
    user_uid: string;
    practices: {
        practice_id: string;
        provider_id: string | null;
        practice_name: string;
        roles: UserRole[];
        permissions: UserPermisions[];
        is_supervisor: boolean;
    }[];
    user_email: string;
    user_contact_phone_no: string;
    first_name: string;
    last_name: string;
    other_name: string;
    preferred_name: string;
    pronouns: string;
    date_of_birth: string;
    default_practice_id?: string | null;
}
export interface IInternalUser {
    user_id: string;
    first_name: string;
    last_name: string;
    roles: string[];
    email: string;
    status: string;
}

export interface IUsersFilterTypes {
    page?: number;
    search_string: string;
    role?: string;
    status?: string;
    limit?: number;
    sort_attribute?: string;
    sort_order?: string;
}

export interface INewUser {
    email: string;
    first_name: string;
    last_name: string;
    roles: string[];
}

export interface INewUsers {
    users: INewUser[];
}

export interface IChangeStatus {
    user_ids: string[];
    status: InternalUsersStatus;
}

export interface IModifyRoles {
    user_ids: string[];
    roles: string[];
}
